/**
 * @ngdoc services
 * @memberof mercury.services
 * @name utils
 * @description Service to hold reusable util functions
 */
angular.module('mercury.services.helperUtils')
.factory('helperUtils', function utils() {

  /**
   * Return the current time as a Unix timestamp.
   *
   * @returns integer representing the number of milliseconds since the Unix epoch
   */
  function now() {
    return Date.now();
  }

  /**
   * set a user time to the current date considering TZ.
   *
   * @returns current date with modified time
   */
  function setTimeToLocalTZ(time) {
    var splittedTime = time.split(':');
    var currentDate = new Date();
    currentDate.setHours(splittedTime[0], splittedTime[1], splittedTime[2]);
    return currentDate.toISOString();
  }

  function getTimeFromLocalTZ(date) {
    return new Date(date).toLocaleTimeString('en-US', {hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit'});
  }

  /**
   * Returns an array of delay values that have been generated using an
   * exponential backoff algorithm. Note the values are in seconds and
   * represent how long to delay from the initial t=0 point.
   *
   * @param {*} initialDelay in seconds
   * @param {*} maxDelay in seconds
   * @returns
   */
  function generateExponentialDelays(initialDelay, maxDelay) {
    var delay = 0;
    var delays = [];
    var i = 0;
    while (
      (delay += initialDelay * Math.pow(2, i)) < maxDelay
    ) {
      delays.push(delay);
      i++;
    }
    return delays;
  }

  function csvEscapeText(text) {
    if (text) {
      return text.toString()
      .replace(/,/g, '\,')
      .replace(/(\r\n|\n|\r|\s+|\t|&nbsp;)/gm, ' ')
      .replace(/"/g, '\"\"')
      .replace(/'/g, '\'');
    } else {
      return null;
    }
  }

  function exportToCsv(data, fileName) {
    if (data && fileName) {
      var csvContent = '';
      data.forEach(function(infoArray, index) {
        dataString = '"' + infoArray.join('","') + '"';
        csvContent += index < data.length ? dataString + '\n' : dataString;
      });
      var download = function(content, fileName, mimeType) {
        var a = document.createElement('a');
        mimeType = mimeType || 'application/octet-stream';
        if (navigator.msSaveBlob) { // IE10
          navigator.msSaveBlob(new Blob([content], {
            type: mimeType
          }), fileName);
        } else if (URL && 'download' in a) {
          a.href = URL.createObjectURL(new Blob([content], {
            type: mimeType
          }));
          a.setAttribute('download', fileName);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          location.href = 'data:application/octet-stream,' + encodeURIComponent(content);
        }
      };
      download(csvContent, fileName, 'text/csv;encoding:utf-8');
    }
  }

  /**
   * Invokes the callback when the window variable with the name provided
   * is available.
   * 
   * This is useful for cases where you need to call a 3rd party library
   * and you aren't sure if the variable is yet available.
   * @param {*} name 
   * @param {*} callback 
   * @returns 
   */
  function waitFor(name, callback) {
    // Check if the window variable is already available
    if (window[name]) {
        callback();
        return;
    }

    // If not available, set up an interval to check periodically
    const interval = setInterval(() => {
        if (window[name]) {
            clearInterval(interval);
            callback();
        }
    }, 100);
  }

  /**
   * Invokes the callback when the DOM element matching the selector provided
   * is available.
   * 
   * This is useful for cases where you have code that needs to reference a DOM
   * element that might not yet have been rendered.
   * @param {*} selector
   * @param {*} callback 
   * @returns 
   */
  function waitForSelector(selector, callback) {
    // Check if the DOM element is already available
    const el = document.querySelector(selector)
    if (el) {
        callback(el);
        return;
    }

    // If not available, set up an interval to check periodically
    const interval = setInterval(() => {
        const el = document.querySelector(selector)
        if (el) {
            clearInterval(interval);
            callback(el);
        }
    }, 100);
  }

  return {
    now: now,
    setTimeToLocalTZ: setTimeToLocalTZ,
    getTimeFromLocalTZ: getTimeFromLocalTZ,
    generateExponentialDelays: generateExponentialDelays,
    csvEscapeText: csvEscapeText,
    exportToCsv: exportToCsv,
    waitFor: waitFor,
    waitForSelector: waitForSelector
  };
});
